export const ActivityStatus = {
    New: "New",
    Started: "Started",
    Completed: "Completed",
  };